export class ThemesApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * List colour checksums for themes the current alias has already shared to the community.
     * Requires identity session.
     */
    async listMySharedChecksums() {
        return this.client.get('/api/themes/me/shared-checksums');
    }
    /**
     * List community themes with optional search/filter.
     * Public endpoint -- no auth required.
     */
    async list(params) {
        const qs = new URLSearchParams();
        if (params?.page)
            qs.set('page', String(params.page));
        if (params?.limit)
            qs.set('limit', String(params.limit));
        if (params?.search)
            qs.set('search', params.search);
        if (params?.tag)
            qs.set('tag', params.tag);
        if (params?.sort)
            qs.set('sort', params.sort);
        const query = qs.toString();
        return this.client.get(`/api/themes${query ? `?${query}` : ''}`);
    }
    /**
     * Get a single community theme by ID.
     * Public endpoint -- no auth required.
     */
    async get(id) {
        return this.client.get(`/api/themes/${encodeURIComponent(id)}`);
    }
    /**
     * Upload/share a theme publicly. Requires identity session.
     */
    async create(data) {
        return this.client.post('/api/themes', data);
    }
    /**
     * Delete a community theme. Requires identity session; must be the author.
     */
    async delete(id) {
        return this.client.delete(`/api/themes/${encodeURIComponent(id)}`);
    }
    /**
     * Upvote a community theme. Requires identity session. Idempotent.
     */
    async upvote(id) {
        return this.client.post(`/api/themes/${encodeURIComponent(id)}/upvote`, {});
    }
    /**
     * Report a community theme. Requires identity session.
     */
    async report(id) {
        return this.client.post(`/api/themes/${encodeURIComponent(id)}/report`, {});
    }
}
//# sourceMappingURL=themes-api.js.map